import { render, staticRenderFns } from "./EditCustomerPoint.vue?vue&type=template&id=c9bf89ba&scoped=true&"
import script from "./EditCustomerPoint.vue?vue&type=script&lang=js&"
export * from "./EditCustomerPoint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9bf89ba",
  null
  
)

export default component.exports